import gql from "graphql-tag";
import actionFormContainer from "./actionFormContainer";
import {cancelSyncClientDispatchWithStord, successSyncClientDispatchWithStord} from "../../../actions/ClientDispatchApiActions";

export default actionFormContainer({
  mutation: gql`
    mutation syncClientDispatchWithStord($data: ClientDispatchIdInput!) {
      syncClientDispatchWithStord(input: $data) {
        errors { key message }
      }
    }
  `,
  resultField: "syncClientDispatchWithStord",
  buildData: (props) => ({clientDispatchId: props.clientDispatchId}),
  formProps: () => ({
    submitLabel: "Check Stord",
    message: "Ask Stord about this order now instead of waiting for the hourly check. If Stord has shipped it, the dispatch ships with what Stord sent; serial numbers Stord reports later are added.",
  }),
  success: successSyncClientDispatchWithStord,
  cancel: cancelSyncClientDispatchWithStord,
});
